import Select from "react-select";
import { AddIcon, DeleteIcon } from "../../../assets/icons";
import chiaviAnnotazioni from "../../../assets/json/chiavi-annotazioni.json";
import { getReactSelectThemeProps } from "../../../helpers/reactSelectThemeStyles";
import CustomTooltip from "../../CustomTooltip";
import "./AnnotazioniSection.scss";

const reactSelectThemeProps = getReactSelectThemeProps();

const CHIAVE_OPTIONS = chiaviAnnotazioni.map((item) => ({
  label: item.chiave,
  value: item.chiave,
}));

const EMPTY_MESSAGE = "Non ci sono annotazioni.";

function getChiaveOption(chiave) {
  if (!chiave) return null;
  return { label: chiave, value: chiave };
}

function getAvailableChiaveOptions(annotazioni, currentIndex) {
  const usedChiavi = annotazioni
    .filter((_, index) => index !== currentIndex)
    .map((annotation) => annotation.chiave)
    .filter(Boolean);

  return CHIAVE_OPTIONS.filter((option) => !usedChiavi.includes(option.value));
}

export default function AnnotazioniSection({
  annotazioni = [],
  onChange,
  disabled = false,
  id = "annotazioni",
  style,
}) {
  const canAddAnnotazione =
    !disabled && annotazioni.length < CHIAVE_OPTIONS.length;

  const handleAdd = () => {
    onChange([...annotazioni, { chiave: "", valore: "" }]);
  };

  const handleDelete = (index) => {
    onChange(annotazioni.filter((_, itemIndex) => itemIndex !== index));
  };

  const handleChiaveChange = (index, selectedOption) => {
    const newAnnotazioni = annotazioni.map((annotation, itemIndex) =>
      itemIndex === index
        ? { ...annotation, chiave: selectedOption?.value ?? "" }
        : annotation
    );
    onChange(newAnnotazioni);
  };

  const handleValoreChange = (index, newValue) => {
    const newAnnotazioni = annotazioni.map((annotation, itemIndex) =>
      itemIndex === index ? { ...annotation, valore: newValue } : annotation
    );
    onChange(newAnnotazioni);
  };

  return (
    <div className="form-block annotazioni-section" id={id} style={style}>
      <div className="annotazioni-section-header">
        <p className="section-title"> ANNOTAZIONI</p>
        {canAddAnnotazione && (
          <CustomTooltip text="Aggiungi annotazione">
            <button
              type="button"
              className="annotazioni-add-button"
              onClick={handleAdd}
            >
              <AddIcon fillColor="var(--archeo-color)" width={24} height={24} />
            </button>
          </CustomTooltip>
        )}
      </div>

      {annotazioni.length ? (
        annotazioni.map((annotation, index) => (
          <div key={index} className="annotazione-row">
            <div className="annotazione-field">
              <label className="annotazione-label">Chiave</label>
              <Select
                {...reactSelectThemeProps}
                options={getAvailableChiaveOptions(annotazioni, index)}
                value={getChiaveOption(annotation.chiave)}
                placeholder="Seleziona chiave"
                isDisabled={disabled}
                onChange={(selectedOption) =>
                  handleChiaveChange(index, selectedOption)
                }
              />
            </div>
            <div className="annotazione-field">
              <label className="annotazione-label">Valore</label>
              <input
                type="text"
                className="annotazione-value-input"
                value={annotation.valore ?? ""}
                placeholder="Inserisci valore"
                disabled={disabled}
                onChange={(event) =>
                  handleValoreChange(index, event.target.value)
                }
              />
            </div>
            {!disabled && (
              <button
                type="button"
                className="annotazione-delete-button"
                onClick={() => handleDelete(index)}
              >
                <DeleteIcon />
              </button>
            )}
          </div>
        ))
      ) : (
        <p className="annotazioni-empty-message">{EMPTY_MESSAGE}</p>
      )}
    </div>
  );
}
